<div class="local-dot-loader">
  <span class="dot"></span>
  <span class="dot"></span>
  <span class="dot"></span>
</div>
